import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import Checkbox from "@mui/material/Checkbox";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import Button from "../common/Button/Button";
import truck from "../../assets/images/truck.png";
import truck1 from "../../assets/images/truck1.png";
import truck2 from "../../assets/images/truck2.png";
import truck3 from "../../assets/images/truck3.png";
import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import Ellipse from "../common/GalleryComponent/Ellipse";
import Play from "../common/GalleryComponent/Play";
import Swipe from "../common/GalleryComponent/Swipe";
import auction from "../../assets/svgs/auction_icon.svg";
import pro from "../../assets/svgs/pro_icon_yellow.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import BottomModal from "../common/Modal/BottomModal";
import BottomShareModal from "../common/Modal/BottomShareModal";
import { useHistory } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
import location from "../../assets/svgs/location_list.svg";
import OnlineAuctionIcon from "../../assets/svgs/onlineAuction.svg";
import AuctionCardImage from "../../assets/svgs/auctionCardImg.svg";

const images = [
  { label: "truck", img: AuctionCardImage },
  { label: "truck1", img: truck1 },
  { label: "truck2", img: truck2 },
  { label: "truck3", img: truck3 },
];

function AuctionCard({
  sx,
  handleSnackbarOpen,
  comparing = false,
  showCompare,
  setShowCompare,
  setShowSimilar,
  setShowShareModal,
  count,
  isPro,
  handleContactSellerModal,
  handleLogInModal,
  loggedIn,
  setContactSellerLoggedIn,
}) {
  const history = useHistory();
  const mobMatch = useMediaQuery("(max-width:600px)");
  const tabMatch = useMediaQuery("(max-width:600px)");
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [showCheckbox, setShowCheckbox] = React.useState(false);
  const [showBottomModal, setShowBottomModal] = React.useState(false);
  const [showBottomShareModal, setShowBottomShareModal] = React.useState(false);
  const [hoverCard, setHoverCard] = React.useState(false);

  const toggleDrawerShare = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowBottomShareModal(open);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowBottomModal(open);
  };

  React.useEffect(() => {
    if (showCompare) {
      setShowCheckbox(false);
    }
  }, [showCompare]);

  const handleClick = (event) => {
    setShowDropdown(event.currentTarget);
    toggleDrawer(true)(event);
  };

  const handleDropdownClose = () => {
    setShowDropdown(false);
  };

  const handleCompare = () => {
    setShowCompare(false);
    handleDropdownClose();
    handleSnackbarOpen();
    setShowCheckbox(true);
  };

  const handleSimilar = () => {
    setShowCompare(false);
    handleDropdownClose();
    setShowSimilar(true);
  };

  const handleShare = () => {
    handleDropdownClose();
    setShowShareModal(true);
  };

  const checkboxClickHandle = (e) => {
    setShowCheckbox(e.target.checked);
    handleSnackbarOpen(e);
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        height: { xs: "auto", sm: 200, md: 160 },
        maxWidth: { xs: "91.5%", sm: "93.8%", md: 876 },
        borderRadius: "8px",
        "&:hover": {
          cursor: "pointer",
        },
        ...sx,
        boxShadow: "none",
        border: { xs: "1px solid #D6D6D6", sm: "none" },
      }}
      onMouseEnter={() => setHoverCard(true)}
      onMouseLeave={() => setHoverCard(false)}
    >
      <Box
        sx={{
          position: "relative",
          width: { xs: "100%", sm: 200, md: 160 },
          height: { sm: 200, md: 160 },
          borderRadius: { xs: "8px", sm: "4px" },
        }}
      >
        {hoverCard && (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              columnGap: "8px",
              position: "absolute",
              bottom: "8px",
              zIndex: "10",
            }}
          >
            {images.map((_, idx) => (
              <Ellipse key={idx} active={idx === activeStep} />
            ))}
          </Box>
        )}
        {hoverCard && (
          <Box
            sx={{
              display: { xs: "none", lg: "flex" },
              justifyContent: "space-between",
              alignItems: "center",
              margin: "0 8px",
              position: "absolute",
              width: "calc(100% - 16px)",
              top: "54px",
              zIndex: "10",
            }}
          >
            <Swipe
              direction="left"
              onClick={handleBack}
              swipeStyle={{
                visibility: activeStep === 0 && "hidden",
              }}
            />
            <Play />
            <Swipe
              direction="right"
              onClick={handleNext}
              swipeStyle={{
                visibility: activeStep === maxSteps - 1 && "hidden",
              }}
            />
          </Box>
        )}
        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            justifyContent: "space-between",
            width: "94%",
            position: "absolute",
            top: 16,
            left: 16,
            zIndex: 10,
          }}
        >
          <Box sx={{ display: "flex", columnGap: "8px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "120px",
                height: "20px",
                backgroundColor: "#fff",
                borderRadius: "4px",
                boxShadow:
                  "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
              }}
            >
              <img
                src={OnlineAuctionIcon}
                style={{ marginRight: "4px" }}
                alt={"auction"}
              />
              <Typography
                variant="caption"
                fontWeight="400"
                fontSize="12px"
                lineHeight="16px"
                color="text.primary"
              >
                On Site Auction
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "64px",
                height: "20px",
                backgroundColor: "#fff",
                borderRadius: "4px",
                boxShadow:
                  "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
              }}
            >
              <img
                src={auction}
                style={{
                  width: "8.77px",
                  height: "8.77px",
                  marginRight: "2px",
                }}
                alt={"auction"}
              />
              <Typography
                variant="caption"
                fontWeight="400"
                fontSize="12px"
                lineHeight="16px"
                color="text.primary"
              >
                Auction
              </Typography>
            </Box>
          </Box>
          {showCheckbox || comparing ? (
            <Checkbox
              sx={{
                width: 16,
                height: 16,
                marginRight: "10px",
                color: "white",
                "&.Mui-checked": {
                  backgroundColor: "white",
                },
              }}
              inputProps={{ "aria-label": "Checkbox demo" }}
              defaultChecked={showCheckbox}
              onClick={checkboxClickHandle}
            />
          ) : (
            <MoreVertIcon
              aria-label="more"
              aria-expanded={showDropdown ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
              sx={{
                display: { xs: "block", md: "none" },
                color: "#FFF",
                marginLeft: "40px",
              }}
            />
          )}
        </Box>
        <SwipeableViews
          axis="x"
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
          style={{ borderRadius: !mobMatch && "8px" }}
        >
          {images.map((step, index) => (
            <div key={step.label}>
              {Math.abs(activeStep - index) <= 2 ? (
                <Box
                  sx={{
                    width: { xs: "100%", sm: 200, md: 160 },
                    height: { xs: "224px", sm: 200, md: 160 },
                    borderRadius: { sm: "8px" },
                    backgroundImage: `url(${step.img})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    objectFit: "cover",
                    overflow: "hidden",
                    boxShadow: "inset 0px 0px 4px rgba(0, 0, 0, 0.5);",
                  }}
                />
              ) : null}
            </div>
          ))}
        </SwipeableViews>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: { xs: "16px", sm: "0", md: "24px" },
          width: { xs: "91.5%", sm: "100%", md: 652 },
          paddingLeft: { sm: "24px", md: "none" },
          paddingBottom: { xs: "0", sm: "auto" },
        }}
      >
        <CardContent
          sx={{
            position: "relative",
            height: { xs: "auto", sm: 200, md: 224 },
            padding: "0",
            width: { xs: "91.5%", sm: "100%", md: 652 },
          }}
        >
          <Box
            sx={{
              display: { xs: "block", sm: "flex" },
              marginBottom: "4px",
              justifyContent: "space-between",
              alignItems: { md: "center" },
            }}
          >
            <Typography
              fontWeight="600"
              color="primary.main"
              sx={{
                width: { xs: "281px", sm: "84%" },
                variant: { xs: "subtitle2", sm: "subtitle1" },
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: { xs: "20px", sm: "24px" },
                marginRight: { xs: "46px", sm: "49px" },
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              January Breda: Agricultural And Construction
            </Typography>
            {!tabMatch && (showCheckbox || comparing) && count > 0 ? (
              <Checkbox
                sx={{
                  width: 16,
                  height: 16,
                  color: "primary.main",
                  marginRight: "5px",
                }}
                inputProps={{ "aria-label": "Checkbox demo" }}
                defaultChecked={showCheckbox}
                onClick={handleSnackbarOpen}
              />
            ) : (
              <>
                <MoreVertIcon
                  aria-label="more"
                  id="long-button"
                  aria-controls="long-menu"
                  aria-expanded={showDropdown ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleClick}
                  sx={{
                    display: { xs: "none", sm: "block" },
                    color: "text.secondary",
                    "&:hover": {
                      color: "primary.main",
                    },
                  }}
                />
                {!tabMatch && (
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      "aria-labelledby": "long-button",
                    }}
                    anchorEl={showDropdown}
                    open={showDropdown}
                    onClose={handleDropdownClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    PaperProps={{
                      sx: {
                        width: 208,
                        "&:hover": {
                          backgroundColor: "#FFF",
                        },
                      },
                    }}
                  >
                    <MenuItem
                      onClick={handleCompare}
                      sx={{
                        backgroundColor: "#FFF !important",
                        "&:hover": {
                          backgroundColor: "#FFF",
                        },
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontSize="14px"
                        color="text.primary"
                        sx={{
                          width: "100%",
                          "&:hover": {
                            color: "primary.main",
                          },
                        }}
                      >
                        Compare this listing
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={handleSimilar}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#FFF",
                        },
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontSize="14px"
                        color="text.primary"
                        sx={{
                          width: "100%",
                          "&:hover": {
                            color: "primary.main",
                          },
                        }}
                      >
                        Find similar listing
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={handleShare}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#FFF",
                        },
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontSize="14px"
                        color="text.primary"
                        sx={{
                          width: "100%",
                          "&:hover": {
                            color: "primary.main",
                          },
                        }}
                      >
                        Share
                      </Typography>
                    </MenuItem>
                  </Menu>
                )}
              </>
            )}
          </Box>
          {/* <Typography
            color="text.primary"
            fontWeight="600"
            sx={{
              variant: { xs: "subtitle2", sm: "subtitle1" },
              fontSize: { xs: "14px", sm: "16px" },
              lineHeight: { xs: "20px", sm: "24px" },
            }}
          >
            AED 800,000
          </Typography> */}
          {/* <Box
            sx={{
              marginTop: { xs: "8px", sm: "16px" },
            }}
          >
            <Box>
              <Box src={calenderIcon} component={"img"} />
              <Typography></Typography>
            </Box>
          </Box> */}
          <Box
            sx={{
              display: "flex",
              marginTop: { xs: "8px", sm: "16px" },
              alignItems: "start",
              flexFlow: { xs: "column", sm: "row" },
              rowGap: "8px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <EventAvailableOutlinedIcon
                sx={{
                  color: "text.secondary",
                  width: "14px",
                  height: "14px",
                  marginRight: "4px",
                }}
              />
              <Typography
                color="text.primary"
                fontWeight="400"
                sx={{
                  variant: { xs: "caption", sm: "body2" },
                  fontSize: { xs: "12px", sm: "14px" },
                  lineHeight: { xs: "16px", sm: "20px" },
                }}
              >
                21 Jan 2022 - 26 Jan 2022
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: { xs: "0px", sm: "16px" },
              }}
            >
              <img
                src={location}
                style={{
                  objectFit: "contain",
                  width: "12px",
                  height: "12px",
                  marginRight: "4px",
                }}
                alt="location"
              />
              <Typography
                color="text.primary"
                fontWeight="400"
                sx={{
                  variant: { xs: "caption", sm: "body2" },
                  fontSize: { xs: "12px", sm: "14px" },
                  lineHeight: { xs: "16px", sm: "20px" },
                }}
              >
                United Arab Emirates
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              marginTop: "16px",
            }}
          >
            <Button
              onClick={() => {
                handleLogInModal(true);
              }}
              variant="contained"
              size="sm"
              bgColor="#F9D548"
              txColor="text.primary"
              sx={{
                width: 104,
                height: 36,
                marginRight: "8px",
                boxShadow: "none",
              }}
              typoVariant="subtitle2"
              hoverBg="#F3C04F"
            >
              View More
            </Button>
            {/* {isPro ? (
            ) : (
              <Button
                variant="outlined"
                size="sm"
                bgColor="#fff"
                txColor="primary.main"
                sx={{
                  width: 137,
                  height: 36,
                  marginRight: "8px",
                  boxShadow: "none",
                }}
                typoVariant="subtitle2"
                hoverBg="primary.main"
                hoverTxColor="white"
                onClick={() =>
                  loggedIn
                    ? setContactSellerLoggedIn(true)
                    : handleContactSellerModal(true)
                }
              >
                Contact Seller
              </Button>
            )} */}
            <Button
              variant="outlined"
              size="sm"
              bgColor="#fff"
              txColor="primary.main"
              sx={{
                width: 81,
                height: 36,
                marginRight: "8px",
                boxShadow: "none",
              }}
              typoVariant="subtitle2"
              startIcon={
                <FavoriteBorderOutlinedIcon
                  sx={{
                    width: "16px",
                    height: "13px",
                    margin: "0",
                    marginRight: "-6px",
                  }}
                />
              }
              hoverBg="primary.main"
              hoverTxColor="white"
            >
              Save
            </Button>
          </Box>
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              flexDirection: "column",
              position: "absolute",
              textAlign: "right",
              bottom: { sm: 0, md: 24 },
              right: { sm: 5, md: 8 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                columnGap: "8px",
                marginTop: "8px",
                justifyContent: "end",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "120px",
                  height: "24px",
                  backgroundColor: "#EBEBEB",
                  borderRadius: "4px",
                }}
              >
                <img
                  src={OnlineAuctionIcon}
                  style={{ marginRight: "4px" }}
                  alt={"auction"}
                />
                <Typography
                  variant="caption"
                  fontWeight="400"
                  fontSize="12px"
                  lineHeight="16px"
                  color="text.primary"
                >
                  On Site Auction
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "120px",
                  height: "24px",
                  backgroundColor: "#EBEBEB",
                  borderRadius: "4px",
                }}
              >
                <img
                  src={auction}
                  style={{ marginRight: "4px" }}
                  alt={"auction"}
                />
                <Typography
                  variant="caption"
                  fontWeight="400"
                  fontSize="12px"
                  lineHeight="16px"
                  color="text.primary"
                >
                  On Site Auction
                </Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Box>
      {tabMatch && (
        <>
          <BottomModal
            open={showBottomModal}
            toggleDrawer={toggleDrawer}
            toggleDrawerShare={toggleDrawerShare}
            setShowCheckbox={setShowCheckbox}
            setShowCompare={setShowCompare}
            handleSnackbarOpen={handleSnackbarOpen}
            setShowSimilar={setShowSimilar}
          />
          <BottomShareModal
            open={showBottomShareModal}
            toggleDrawer={toggleDrawerShare}
          />
        </>
      )}
    </Card>
  );
}

export default AuctionCard;
